import clsx from "clsx"
import styles from "@styles/Button.module.css"
import { GoogleCalendarResponseStatus } from "@/app/helpers/google/calendar/fetchCalendarEvents"

export const CalendarRSVPButton = ({
  onClick,
  rsvpType,
  isSelected = false,
}: {
  onClick: () => void
  rsvpType: GoogleCalendarResponseStatus
  isSelected: boolean
}) => {
  const label =
    rsvpType === "accepted"
      ? "Attend"
      : rsvpType === "tentative"
        ? "Maybe"
        : rsvpType === "declined"
          ? "Decline"
          : ""

  return (
    <button
      className={clsx(
        styles.container,
        styles.default,
        styles.calendarRSVP,
        styles[rsvpType],
        !isSelected && styles.notSelected,
      )}
      onClick={onClick}
    >
      <span className={styles.label}>{label}</span>
    </button>
  )
}
